import { useContext, useEffect, useRef } from 'react';

import { Outlet } from 'react-router-dom';

import Chat from '@components/Chat/Chat';
import Header from '@components/Header/Header';
import Footer from '@components/Footer/Footer';

import { ResizablePanelGroup, ResizablePanel, ResizableHandle } from '@utils/resizable';

import { SessionContext } from '@contexts/SessionProvider';

import styles from './Chat.module.scss';

const ChatLayout = () => {
    const chatPanelRef = useRef<any>(null);

    const { isChatCollapsed, setIsChatCollapsed } = useContext(SessionContext);

    useEffect(() => {
        if (!chatPanelRef.current) return;

        if (isChatCollapsed) {
            // Collapse left panel to 0
            chatPanelRef.current.resize(0);
        } else {
            // Expand it back to defaultSize (e.g. 25)
            chatPanelRef.current.resize(25);
        }
    }, [isChatCollapsed]);

    const handleResize = (size: number) => {
        if (size === 0 && !isChatCollapsed) {
            setIsChatCollapsed(true);
        } else if (size > 0 && isChatCollapsed) {
            setIsChatCollapsed(false);
        }
    };

    return (
        <div className={styles['chat-layout']}>
            <Header />
            <div className={styles.body}>
                <ResizablePanelGroup direction="horizontal">
                    <ResizablePanel
                        ref={chatPanelRef}
                        defaultSize={25}
                        minSize={0}
                        maxSize={35}
                        onResize={handleResize}>
                        <Chat />
                    </ResizablePanel>

                    <ResizableHandle withHandle />

                    <ResizablePanel defaultSize={75}>
                        <Outlet />
                    </ResizablePanel>
                </ResizablePanelGroup>
                <Footer />
            </div>
        </div>
    );
};

export default ChatLayout;
